import CompareFaculty from "Benchmarking/Pages/CompareFaculty";
import CompareInstitution from "Benchmarking/Pages/CompareInstitution";
import FacultyDetail from "Benchmarking/Pages/FacultyDetail";
import FacultyProfiles from "Benchmarking/Pages/FacultyProfiles";
import Home from "Benchmarking/Pages/Home";
import InstitutionDetail from "Benchmarking/Pages/InstitutionDetail";
import InstitutionProfiles from "Benchmarking/Pages/InstitutionProfiles";
import RankFaculty from "Benchmarking/Pages/RankFaculty";
import RankInstitution from "Benchmarking/Pages/RankInstitution";
export const _routes = [
  {
    path: "/",
    exact: true,
    component: Home,
    name: "Home",
    permissions: [],
  },

  {
    path: "/faculty/profile/:id",
    exact: true,
    component: FacultyDetail,
    name: "Faculty detail",
    permission: [],
  },
  {
    path: "/institution/profile/:id",
    exact: true,
    component: InstitutionDetail,
    name: "Institution detail",
    permission: [],
  },
  {
    path: "/faculty/profile",
    exact: true,
    component: FacultyProfiles,
    name: "Faculty profiles",
    permission: [],
  },
  {
    path: "/faculty/rank",
    exact: true,
    component: RankFaculty,
    name: "Rank Faculty",
    permission: [],
  },
  {
    path: "/faculty/compare",
    exact: true,
    component: CompareFaculty,
    name: "Compare Faculty",
    permission: [],
  },
  {
    path: "/institution/profile",
    exact: true,
    component: InstitutionProfiles,
    name: "Institution profiles",
    permission: [],
  },
  {
    path: "/institution/rank",
    exact: true,
    component: RankInstitution,
    name: "Rank Institution",
    permission: [],
  },
  {
    path: "/institution/compare",
    exact: true,
    component: CompareInstitution,
    name: "Compare Institution",
    permission: [],
  },
];
